// latest code with carousel and auto-slide functionality

import React, { useState, useEffect, useCallback } from "react";
import { portalLink } from "../utils/portal";

const POPULAR_PROGRAMS = [
  { label: "Executive Architect Program", href: "/course-executive-architect" },
  { label: "Executive Interior Program", href: "/course-executive-interior" },
  { label: "Customized your own program", href: "/customise-your-program" },
  // { label: "Urban Planning & BIM", href: "/course-urban-planning" },
  // { label: "Construction Management", href: "/course-construction-management" },
];

const AGENDA_ITEMS = [
  {
    label: "Find a Job",
    href: "/jobs",
    icon: (
      <>
        <rect x="3" y="7" width="18" height="13" rx="1" />
        <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      </>
    ),
  },
  {
    label: "Hire Talent",
    href: "/hire",
    icon: (
      <>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
      </>
    ),
  },
  {
    label: "Explore a Program",
    href: "#programs",
    icon: (
      <>
        <path d="M12 3L1 9l11 6 9-4.9V17h2V9L12 3z" />
        <path d="M5 12v5c3 2 11 2 14 0v-5" />
      </>
    ),
  },
  {
  label: "Onboard Your College",
  href: portalLink("/college-register"),
  icon: (
    <>
      <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h1M9 13h1M14 9h1M14 13h1" />
    </>
  ),
},
];

 
const HERO_STATS = [
  { num: "5K", sup: "+", label: "Working Professionals" },
  { num: "500", sup: "+", label: "Hiring Partners" },
  { num: "20", sup: "+", label: "Trainers " },
  { num: "10", sup: "+", label: "Colleges" },
];

// 4 slides for the hero visual carousel — swap image URLs / captions as needed
const HERO_SLIDES = [
  {
    img: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=900&q=75",
    alt: "IPDI ecosystem — students, colleges and firms",
    tagPrefix: "From Classroom to",
    tagEm: "Career",
    tagSuffix: "— One Ecosystem.",
  },
  {
    img: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=900&q=75",
    alt: "Students collaborating on design projects",
    tagPrefix: "Learn from",
    tagEm: "Industry Experts",
    tagSuffix: "who build real projects.",
  },
  {
    img: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=900&q=75",
    alt: "Architecture studio and campus life",
    tagPrefix: "40+ Colleges,",
    tagEm: "One Standard",
    tagSuffix: "of design education.",
  },
  {
    img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=900&q=75",
    alt: "Placement and hiring partners",
    tagPrefix: "60+ Companies",
    tagEm: "Hiring",
    tagSuffix: "directly from IPDI.",
  },
];

export default function Hero() {
  const [searchValue, setSearchValue] = useState("");
  const [slideIndex, setSlideIndex] = useState(0);

  const goToSlide = useCallback((index) => {
    setSlideIndex((index + HERO_SLIDES.length) % HERO_SLIDES.length);
  }, []);

  const prevSlide = () => goToSlide(slideIndex - 1);
  const nextSlide = () => goToSlide(slideIndex + 1);

  // auto-slide every 5s, pauses are not implemented on purpose to keep it simple
  useEffect(() => {
    const timer = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % HERO_SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const activeSlide = HERO_SLIDES[slideIndex];

  return (
    <section className="hero">
      <div className="hero-bg">
        <div className="hero-bg-img"></div>
        <div className="hero-grad"></div>
        <div className="hero-grid"></div>
      </div>

      <div className="hero-top">
        <div className="hero-copy">
          <div className="hero-badge">
            <div className="badge-dot"></div>
            <span className="badge-text">
              Now Onboarding — Students, Colleges &amp; Companies
            </span>
          </div>

          {/* <h1 className="hero-h1">
            <span style={{ display: "block" }}>One Ecosystem.</span>   
            <span className="l2" style={{ display: "block" }}>
              Every <em>Path</em> in Design.
            </span>
          </h1> */}

  {/* <p className="hero-sub">
            IPDI is India's connected ecosystem for architecture &amp; design —
            bringing students, colleges and hiring firms onto one platform,
            built for real practice.
          </p> */}

           {/* <h1 className="hero-h1">
            <span  >Empowering Architects & Designers to  </span>  
            <span className="l2" >
             <em> Learn, Get Hired & Grow.</em> 
            </span>
          </h1> */}

           {/* <h1 className="hero-h1">
            <span  >One ecosystem for every <br />
               architect & designer.</span>  <br />
            <span className="l2" > 
              Discover - Connect - Get Hired - Grow
            </span>
          </h1> */}

          <h1 className="hero-h1">
  <span>One ecosystem for every architect & designer.</span>
  <span className="l2">Discover - Connect - Get Hired - Grow</span>
</h1>

          {/* <p className="hero-sub">
            IPDI is India's dedicated career ecosystem connecting students, professionals, colleges, and companies through one integrated platform.  
          </p> */}
          

          <div className="hero-tagline-badge">
            <svg viewBox="0 0 24 24">
              <path d="M20 6L9 17l-5-5" />
            </svg>
            <span>100% Placement Assurance Programs</span>
          </div>

          <div className="hero-search-block">
            {/* <div className="hero-search-lbl">Find Your Program</div> */}
            <div className="hero-search-field">
              <input
                type="text"
                // placeholder='Try "Interior Design" or "BIM Technology"...'
                placeholder='Find Your Program...'
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <button aria-label="Search" type="button">
                <svg viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="7" />
                  <path d="M21 21l-4.3-4.3" />
                </svg>
              </button>
            </div>
            <div className="hero-search-suggest">
              <div className="hs-suggest-lbl">Popular Programs</div>
              {POPULAR_PROGRAMS.map((program) => (
                <a href={program.href} className="hs-suggest-item" key={program.label}>
                  {program.label}
                  <span className="tag">100% Placement</span>
                </a>
              ))}
            </div>
          </div>

          <div className="hero-agenda-lbl">
            <svg viewBox="0 0 24 24">
              <path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z" />
            </svg>
            What brings you to IPDI?
          </div>
          <div className="agenda-grid">
            {AGENDA_ITEMS.map((item) => (
              <a href={item.href} className="agenda-pill" key={item.label}>
                <svg viewBox="0 0 24 24">{item.icon}</svg>
                {item.label}
              </a>
            ))}
          </div>

          {/* <a href="#programs" className="hero-browse-link">
            View all programs
            <svg
              viewBox="0 0 24 24"
              stroke="currentColor"
              fill="none"
              strokeWidth="2"
              width="10"
              height="10"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a> */}
        </div>

        <div className="hero-visual">
          <div className="hero-visual-frame">
            {HERO_SLIDES.map((slide, i) => (
              <img
                key={slide.img}
                src={slide.img}
                alt={slide.alt}
                className={
                  "hero-slide-img" + (i === slideIndex ? " is-active" : "")
                }
              />
            ))}

            <button
              type="button"
              className="hero-vis-arrow lft"
              aria-label="Previous image"
              onClick={prevSlide}
            >
              ‹
            </button>
            <button
              type="button"
              className="hero-vis-arrow rgt"
              aria-label="Next image"
              onClick={nextSlide}
            >
              ›
            </button>

            <div className="hero-vis-tag">
              {activeSlide.tagPrefix} <em>{activeSlide.tagEm}</em>{" "}
              {activeSlide.tagSuffix}
            </div>

            <div className="hero-vis-dots">
              {HERO_SLIDES.map((slide, i) => (
                <button
                  key={slide.img}
                  type="button"
                  aria-label={`Go to slide ${i + 1}`}
                  className={"hero-vis-dot" + (i === slideIndex ? " is-active" : "")}
                  onClick={() => goToSlide(i)}
                />
              ))}
            </div>
          </div>
          <div className="hero-float-card">
            <div className="fc-eyebrow">Join the Ecosystem</div>
            <div className="fc-title">
              4,000+ Students · 40+ Colleges · 60+ Hiring Partners
            </div>
            <div className="fc-sub">
              One platform connecting education and industry, end to end.
            </div>
          </div>
        </div>
      </div>

      <div className="hero-stats">
        {HERO_STATS.map((stat) => (
          <div className="h-stat" key={stat.label}>
            <span className="h-num">
              {stat.num}
              {stat.sup && <sup>{stat.sup}</sup>}
            </span>
            <span className="h-lbl">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}